import Util from "./utils"
import Const from "./const"
import dayjs from "dayjs"
import { get } from 'lodash';

/* ======== 时间处理 ========== */
export function timeFilter(value, type = 1) {
    if (value == null) return '';
    if (value.toString() === '0') return '-';

    switch (type) {
        case 1: return dayjs.unix(value).format('YYYY-MM-DD HH:mm:ss');
        case 2: return dayjs.unix(value).format('YYYY年MM月DD日');
        case 3: return dayjs(value).format('YYYY年MM月DD日');
        case 4: return dayjs.unix(value).format('YYYY-MM-DD');
        case 5: return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
        case 6: return dayjs.unix(value).format('YYYY-MM-DD HH:mm');
        case 7: return dayjs(value).format('YYYY-MM-DD HH:mm:ss:SSS');
        case 8: return dayjs.unix(value).format('HH:mm');
        default: return '-';
    }
};
export function timeFormat(timestamp, format) {
    if (timestamp == null) return '';
    if (timestamp.toString() === '0') return '-';
    return dayjs.unix(timestamp).format(format)
}
export function dayFilter(val, type = 1) {
    // 对 'YYYYMMDD' 转换
    if (!val) return '';
    val = val.toString();
    switch (type) {
        case 1: return `${val.slice(0, 4)}-${val.slice(4, 6)}-${val.slice(6)}`
        case 2: return `${val.slice(0, 4)}-${val.slice(4, 6)}`
    }
}
export function minToHour (val) {
    if (!val) return '0时0分';
    if (val <= 60) {
        return '0时' + val + '分'
    }
    let h = ~~(val / 60)
    let min = ~~(val % 60)
    return `${h}时${min}分`
}
export function minToHourCustomUnit (val, unit_type = 1) {
    let hourUnit = '时'
    let minUnit = '分'
    switch (unit_type) {
        case 1:
            hourUnit = '时'
            minUnit = '分'
            break;
        case 2:
            hourUnit = '小时'
            minUnit = '分钟'
            break;
    }
    
    if (!val) return `0${hourUnit}0${minUnit}`;
    if (val <= 60) {
        return `0${hourUnit}${val}${minUnit}`;
    }
    let h = ~~(val / 60)
    let min = ~~(val % 60)
    return `${h}${hourUnit}${min}${minUnit}`
}
/**
 * 
 * @param {*} val 
 * @param {*} data_type 返回的数据类型 默认：值<60时，输出'0时x分'
 * @returns 
 */
export function minToHourObj (val, data_type = '') {
    if (!val) {
        if (!data_type) {
            return '0时0分'
        } else if (data_type == 'obj') {
            return {h: 0, min: 0}
        } else {
            return {}
        }
    };
    if (val <= 60) {
        if (!data_type) {
            return '0时' + val + '分'
        } else if (data_type === 'obj') {
            return { h: 0, min: val }
        } else {
            return {}
        }
    }
    let h = ~~(val / 60)
    let min = ~~(val % 60)
    return { h, min }
}
export function minuteFilter (val, type = 1, dp = 2) {
    if (!val) return val;
    switch (type) {
        case 1: return (val / 60).toFixed(dp)
    }
}
/**
 * @description 计算两个时间点之间的间隔 格式 (X天)(X小时)X分
 * @param {timestamp} begin    开始时间的 秒时间戳 必传
 * @param {timestamp} end      结束时间的 秒时间戳 可空 默认为当前时间
 * @param {timestamp} second   是否计算秒 可空 
 * @param {timestamp} dayUnit  时间的 单位 可空 默认为'天'
 * @param {timestamp} hourUnit 时间的 单位 可空 默认为'时'
 * @param {timestamp} minUnit  时间的 单位 可空 默认为'分'
 */
export function occupyTimeFilter(begin, end, second, dayUnit = '天', hourUnit = '时', minUnit = '分') {
    if (!begin) { return '' }

    if (second) {
        begin = dayjs.unix(begin)
        end = end ? dayjs.unix(end) : dayjs()
    } else {
        begin = dayjs.unix(begin).second(0)
        end = end ? dayjs.unix(end).second(0) : dayjs().second(0)
    }

    let totalDiffD = end.diff(begin, 'd') // 总共相差的天数
    let totalDiffH = end.diff(begin, 'h') // 总共相差的小时数
    let totalDiffM = end.diff(begin, 'm') // 总共相差的分钟数
    let totalDiffS = end.diff(begin, 's') // 总共相差的秒数

    let diffH = totalDiffH - 24 * totalDiffD // 减去天数后，相差的小时数
    let diffM = totalDiffM - 60 * totalDiffH // 减去小时数后，相差的分钟数
    let diffS = totalDiffS - 60 * totalDiffM // 减去分钟数后，相差的秒数

    if (diffS) diffM++ // 不足一分钟按一分钟计算

    let str = ''
    str += totalDiffD ? totalDiffD + dayUnit : ''
    str += diffH ? diffH + hourUnit : ''
    str += diffM ? diffM + minUnit : ''
    // str += diffS ? diffS + '秒' : ''

    return str
}
/* ======== 时间处理 ========== */


/* ======== 通用方法 ========== */
export function countFilter(val = 0, divisor = 100, dp = 2, type = false) {
    if (val == 0) { return 0 }
    if (type) {
        return parseFloat((val * divisor).toFixed(dp))
    } else {
        return parseFloat((val / divisor).toFixed(dp))
    }
}
export function moneyFilter(val, type = 1, dp = 2) {
    if (!val) {
        switch (type) {
            case 1: return Number(0).toFixed(dp);
            case 2: return '-'
            case 3: return '￥' + Number(0).toFixed(dp);
        }
    }
    switch (type) {
        case 1: return (val / 100).toFixed(dp);
        case 2: return '￥' + (val / 100).toFixed(dp);
        case 3: return '￥' + (val / 100).toFixed(dp);
    }
}
export function avatarFormat(item) {
    if (!item) {
        console.warn("没有找到图像")
        return
    }
    if (typeof item === 'object') {
        console.warn(`util内getAvatar函数用法不正确, 不能从对象中获取, 请传入字符串`)
        return
    } else {
        if (item.indexOf("http") >= 0 || item.substring(0, 2) === '//') {
            return item
        } else {
            return Const.NET.IMG_URL_PREFIX + item
        }
    }
}
export function addressFilter(obj, type = 1) {
    const province = obj.province || '';
    const city = obj.city || '';
    const county = obj.county || '';
    const detail = obj.address || '';
    if (!province && !city && !county && !detail) {
        return '-'
    }
    switch (type) {
        case 1:
            if (!province && !city && !county && !detail) return '-';
            return `${province} ${city} ${county} ${detail}`;
        case 2:
            if (!province && !city && !county) return '-';
            return `${province} ${city} ${county}`
    }
}
// 性别
export function genderFormat (gender) {
    const GENDER = Const.GENDER
    switch (gender) {
        case GENDER.MALE: return "男"
        case GENDER.FEMALE: return "女"
        default: return "保密"
    }
}
// 金额变动
export function moneyChangeTypeFilter (val, to = 'text') {
    const MAP = Const.MONEY_CHARGE_MAP;
    const ITEM = MAP[val + ''] || {};
    return ITEM[to] || ''
}
// 表格字段过滤
export function tableFieldsFilter (columns = [], role) {
    if (!columns.length) {
        return []
    }
    let tableFields = columns.filter(item => {
        return item.role === undefined || item.role.includes(role)
    })
    return tableFields
}

export function valueFilter(val, form, to = 'text', def = "未知") {
    const MAP = typeof form === 'string' ? get(Const, form, {}) : form;
    const ITEM = MAP[val + ''] || { [to]: def }
    return ITEM[to] || ''
}

export function itemFilter(val, path, to, def) {
    const LIST = get(Const, path, []);
    const ITEM = LIST.find(item => item.value === parseInt(val)) || {}
    return (to ? ITEM[to] : ITEM) || def
}

/**
 * 数值格式化显示函数
 * @param {number} val - 要格式化的数值
 * @param {number} divisor - 除数（10的n次方）
 * @returns {string} 格式化后的字符串
 * 
 * 功能说明：
 * - 当divisor为10的n次方时，计算总小数位数并显示
 * - 不做四舍五入，直接截断到指定小数位
 * - 示例：countShow(123.456, 100) → "1.23456"
 */
export function countShowFilter(val = 0, divisor = 100) {
    if (val == 0) { return 0 }
    
    // 计算原始值的小数位数
    let len = String(val).split('.')[1]?.length || 0;
    
    // 计算除数对应的位数（divisor为10的n次方时，log10结果为n）
    let log10 = Math.log10(divisor) || 0;
    
    // 总小数位数 = 原始值小数位数 + 除数对应的位数
    let dp = len + log10;
    
    // 按小数点位数展示，不做四舍五入
    return (val / divisor).toFixed(dp)
}
/* ======== 通用方法 ========== */


/* ======== 运营商管理 && 片区管理 && 充电站管理 ========== */
// 第三方支付
export function paymentChannelFilter(val, to = 'text') {
    const MAP = Const.OPERATOR.PAYMENT_CHANNEL_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 运营商等级
export function operatorLevelFilter(operator) {
    let path = operator.path.split('/').filter(i => i)
    const MODE = Const.OPERATOR.MODE
    if (operator.parent_mode === MODE.DISTRIBUTOR && operator.mode === MODE.DIRECTSALES) {
        return '1级'
    }
    return path.length + '级'
}

// 充电站审核
export function stationAuditFilter (val, to = 'text') {
    const MAP = Const.STATION.CHECK_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
// 子运营商状态
export function accountStatusFilter (status, type = 'word') {
    const STATUS = Const.ACCOUNT_STATUS
    switch (type) {
        case 'word':
            switch (status) {
                case STATUS.USEING: return '启用中'
                case STATUS.FORBIDDEN: return '禁用中'
                default: return '启用中'
            }
            break;
        case 'class':
            switch (status) {
                case STATUS.USEING: return 'enable'
                case STATUS.FORBIDDEN: return 'ban'
                default: return 'enable'
            }
            break;
    }
}

// 充电站类型
export function stationTypeFilter (val, to = 'text') {
    const MAP = Const.STATION.TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
/* ======== 运营商管理 && 片区管理 && 充电站管理 ========== */


/* ======== 设备管理 ========== */
// 设备类型
export function deviceTypeFilter(val, to = 'text') {
    const MAP = Const.DEVICE.TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 插口列表
export function portListFilter (list = [], device) {
    try {
        let port_count = Util.getPortCount(device);

        let device_mark = Util.deviceTypeMark(device);

        let device_info = {
            ...device_mark,
            port_count,
        }

        return disposePortList(list, device_info);
    } catch (err) {
        console.log("portListFilter err:", err);
        return {};
    }
}

/** 处理插孔列表 */
export function disposePortList(list = [], device_info = {}) {
    try {
        if (Util.isEmptyObj(device_info)) {
            throw {
                messgae: '传入参数错误',
            }
        }

        const { 
            mark,     
            type,                       // 设备类型
            port_count = 2,             // 端口数量
            device_car = false,         // 汽车充设备
            device_single_car = false,  // 单枪汽车充设备
            device_double_car_special = false,  // 双枪汽车充设备 port_index 从1开始
            device_tank = false,        // 充电柜设备
            device_cabinet = false,     // 换电柜设备
            device_gate = false,        // 道闸设备
            device_plug = false,        // 两轮充设备
        } = device_info;

        if (!mark) {
            throw {
                messgae: 'mark错误',
            }
        }

        list = list.filter(i => i.port_index >= 0); // 排除port_index不正常的项

        let port_list = [];
        let emergency_state = 0;

        if (port_count == 1) { // 单孔设备
            let item = list.find(item => item.port_index == 1) || {};
            port_list = [{ ...item, port_index: 1, port_name: device_single_car ? 2 : 1 }];
        } else {
            if (device_double_car_special) {
                port_list = new Array(port_count).fill({}).map((o, i) => ({ port_index: i + 1, port_name: i + 1 }));
                list.forEach((item) => {
                    if (item.port_index <= port_count) {
                        let { port_index, port_name } = port_list[item.port_index - 1];
                        port_list[item.port_index - 1] = { ...item, port_index, port_name };
                    }
                });
            } else {
                port_list = new Array(port_count).fill({}).map((o, i) => ({ port_index: i, port_name: i + 1 }));
                list.forEach(item => {
                    if ((item.port_index + 1) <= port_count) {
                        let { port_index, port_name } = port_list[item.port_index];
                        port_list[item.port_index] = { ...item, port_index, port_name };
                    }
                });
            }
        }

        if (port_count <= 2 && !device_car) {
            // 除 汽车充系列产品 以外，双孔或单孔的插口显示名称改为A/B
            port_list.forEach(item => item.port_name = Const.DEVICE.PORT_NAME.NORMAL[item.port_name]);
        }

        if (device_car) {
            // 汽车充系列产品
            port_list.forEach(item => {
                item.port_name = port_count <= 2 ? Const.DEVICE.PORT_NAME.CAR[item.port_name] : `${item.port_name}`,
                emergency_state += item.emergency_button_state
            });
        }
        else if (device_tank) {
            // 充电柜系列产品
            port_list.forEach(item => {
                if (item.charge_status === 1) {
                    item.status = 'working';
                } else {
                    item.status = item.cabinet_status ? 'occupy' : 'empty';
                }
                if (item.online === 0) {
                    item.status = 'fault';
                }
            })
        }
        else if (device_cabinet) {
            // 换电柜系列产品
            port_list.forEach(item => {
                // item.row = 3
                let { flag_has_battery, battery = {}, online } = item;
                item.soc = battery.soc;
                item.rated_voltage = battery.rated_voltage;

                if (flag_has_battery) {
                    item.status = battery.soc >= 90 ? 'high' : 'low'
                } else {
                    item.status = 'empty';
                }
                if (online == 0) {
                    item.status = 'fault';
                }
            })
        }


        // 获取端口名字
        port_list.forEach(item => {
            item.custom_port_name = Util.getPortName({
                port_index: item.port_index, 
                device_type: type, 
                device_port_count: port_count,
            }, '', true);
        });


        console.log('disposePortList port_list:', port_list);
        return { port_list, emergency_state, device_mark: device_info };
    } catch (err) {
        console.log("disposePortList err:", err);
        return {};
    }
}

// 插口状态
export function portStatusFilter(port, device, type = 'text') {
    try {
        let device_mark = Util.deviceTypeMark(device);

        let result = {};

        const { 
            mark,     
            port_count = 2,             // 端口数量
            device_car = false,         // 汽车充设备
            device_single_car = false,  // 单枪汽车充设备
            device_tank = false,        // 充电柜设备
            device_cabinet = false,     // 换电柜设备
            device_gate = false,        // 道闸设备
            device_plug = false,        // 两轮充设备
        } = device_mark;
        
        if (device_car) {
            // 汽车充
            if (port.plug_in === 1) {
                if (port.occupy_status) {
                    // 被占用  定义：充电已结束，但是充电枪还与车链接未拔出归位的状态
                    result = { text: '被占用', status: 'warning', color: 'gold' }
                } else if (port.charge_status === 4) {  // 已预约
                    result = { text: '已预约', status: 'processing', color: 'blue' }
                } else{
                    result = port.transaction_id ? { text: '充电中', status: 'processing', color: 'blue' } : { text: '充电枪已插入', status: 'default', color: 'cyan' }
                }
            } else {
                result = { text: '空闲', status: 'success', color: 'green' }
            }
            return result[type]
        }
        else if (device_tank) {
            // 充电柜
            switch (port.status) {
                case 'working': result = { text: '充电中', status: 'processing', color: 'blue' }; break;
                case 'occupy': result = { text: '占用中', status: 'warning', color: 'gold' }; break;
                case 'empty': result = { text: '空闲', status: 'success', color: 'green' }; break;
                case 'fault': result = { text: '故障', status: 'error', color: 'red' }; break;
            }
        }
        else if (device_cabinet) {
            // 换电柜
            switch (port.status) {
                case 'high': result = { text: '高电量', status: 'processing', color: 'blue' }; break;
                case 'low': result = { text: '低电量', status: 'processing', color: 'gold' }; break;
                case 'empty': result = { text: '空闲', status: 'success', color: 'green' }; break;
                case 'fault': result = { text: '故障', status: 'error', color: 'red' }; break;
            }
        } else {
            result = port.transaction_id
                ? { text: '充电中', status: 'processing', color: 'blue' }
                : { text: '空闲', status: 'success', color: 'green' };
        }
        return result[type]
    } catch (err) {
        console.log("portStatusFilter err:", err);
        return '';
    }
}

// 服务费 获取 设备名称
export function serviceChargePowerDeviceTypeFilter(device, to = 'word') {
    try {
        if (Util.isEmptyObj(device)) {
            throw {
                message: '设备信息错误',
            }
        }

        let uid = device.device_uid || '';
        let uid_slice = Util.uidSlice(uid);
        // console.log("powerDeviceTypeFilter ~ uid:", uid);
        // console.log("powerDeviceTypeFilter ~ uid_slice:", uid_slice);

        if (uid.length !== 14) {
            return powerDeviceTypeFilter(device, to);
        }

        const PORT_MARK = Const.DEVICE.PORT_MARK;

        // 动态获取 PORT_MARK 中的所有数组并合并到 ALL_PORT_MARK
        const ALL_PORT_MARK = Object.values(PORT_MARK).reduce((acc, item) => {
            if (Array.isArray(item)) {
                return [...acc, ...item];
            }
            return acc;
        }, []); 

        switch (to) {
            case 'word':
                // 网关
                if (!device.device_model && !ALL_PORT_MARK.includes(uid_slice)) {
                    return "网关";
                }
                // 获取 设备名称 及 允许最大功率
                return powerDeviceTypeFilter(device, to);
        }
    } catch (err) {
        console.log("powerDeviceTypeFilter err:", err);
        return '-';
    }
}

// 获取 设备名称 及 允许最大功率
export function powerDeviceTypeFilter(device, to = 'word') {
    // console.log("powerDeviceTypeFilter ~ device:", device)
    try {
        if (Util.isEmptyObj(device)) {
            throw {
                message: '设备信息错误',
            }
        }

        let uid = device.uid || device.device_uid || '';
        // console.log("powerDeviceTypeFilter ~ uid:", uid);

        switch (to) {
            case 'word':
                let name = '';
                if (device.device_model) {
                    name = device.device_model.name;
                } else  if (device.name) {
                    name = device.name;
                } else {
                    name = Util.getDeviceInfoByUid(uid, 'word');
                }
                return name;
            case 'power':
                let power = '';
                let config_key = Util.getDeviceModelConfigKeyByDeviceType(device);
                // console.log("powerDeviceTypeFilter ~ config_key:", config_key)
                if (device.device_model && config_key) {
                    power = Util.getDeviceModelConfigByKey(device.device_model, config_key);
                } else {
                    power = Util.getDeviceInfoByUid(uid, 'power');
                }
                return power;
        }
    } catch (err) {
        console.log("powerDeviceTypeFilter err:", err);
        return '-';
    }
}

// 电池状态
export function batteryStatusFilter (val, to = 'text') {
    const MAP = Const.BATTERY.STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 经纬度标识
export function batteryGpsStatusFilter (val, to = 'text') {
    const MAP = Const.BATTERY.GPS_STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// MOS状态
export function batteryMosStatusFilter (val, to = 'text') {
    const MAP = Const.BATTERY.MOS_STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 电池类型
export function batteryTypeFilter (val, to = 'text') {
    const MAP = Const.BATTERY.TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 设备任务 设备参数类型 通过设备添加
export function deviceTaskTypeFilter(val, to='text') {
    const MAP = Const.DEVICE_TASK.POWER_TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 设备任务 设备参数类型 通过站点添加
export function deviceTaskStationTypeFilter(val, to='text') {
    const MAP = Const.DEVICE_TASK.POWER_TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}

// 设备任务 设备成员状态
export function deviceTaskStatusFilter (val, to = 'text') {
    const MAP = Const.DEVICE_TASK.STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}

// 设备任务 参数详情
export function deviceTaskParamsFilter(params, type) {
    let maxPower = Object.hasOwn(params, 'max_power') ? Util.deepCopy(Const.DEVICE_TASK.PARAMS_POWER_LIST) : Util.deepCopy(Const.DEVICE_TASK.PARAMS_NEW_LIST)
    let list = type ? maxPower : Util.deepCopy(Const.DEVICE_TASK.PARAMS_LIST)
    let str = ''
    for (const item of list) {
        if (params[item.key] !== undefined) {
            item.flag = true
            item.value = params[item.key]
            if (item.key !== 'max_power_list') {
                str += `${item.text}: ${countFilter(item.value, item.divisor, item.precision)} ${item.unit}\n`
            } else {
                str += `${item.text}: ${'点击详情查看'}\n`
            }
        }
    }
    return str
}
// 设备任务 设备成员状态
export function deviceTaskMemberStatusFilter (val, to = 'text') {
    const MAP = Const.DEVICE_TASK.MEMBER_STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}

export function portNameFilter (val, map = 'NORMAL') {
    const MAP = Const.DEVICE.PORT_NAME[map] || {}
    return MAP[val] || val
}

// 设备类型
export function categoryTypeFilter(val, to = 'text') {
    const MAP = Const.DEVICE.CATEGORY_TYPE_NEW_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}

/* ======== 设备管理 ========== */

/* ======== 道闸管理 ========== */
// 道闸类型
export function gateTypeFilter (val, to = 'text') {
    const MAP = Const.GATE.TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || ''
}
// 道闸工作类型
export function gateStatusFilter (val, to = 'text') {
    const MAP = Const.GATE.STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}

// 道闸开关闸记录 状态
export function gateActionStatusFilter (val, to = 'text') {
    const MAP = Const.GATE.ACTION_STATUS_MAP
    const ITEM = MAP[val + ''] || { text: "未知状态", color: 'gray' }
    return ITEM[to] || '-'
}
// 道闸开关闸记录 结束原因
export function gateActionFinishFilter (val) {
    const MAP = Const.GATE.ACTION_FINISH_CODE_MAP
    return MAP[val + ''] || '-'
}
/* ======== 道闸管理 ========== */


/* ======== 计费模板管理 ========== */
// 计费模版类型
export function chargeTempFilter (val, to = 'text') {
    const MAP = Const.CHARGE.TYPE_MAP
    const ITEM = MAP[val + ''] || { text: "未录入的计费方式" }
    return ITEM[to] || '-'
}
// 充电订单 计费模版类型
export function chargeModeFilter (val, to = 'text') {
    const MAP = Const.CHARGE.CHARGE_MODE_MAP
    const ITEM = MAP[val + ''] || { text: "未录入的计费方式" }
    return ITEM[to] || '-'
}
// 计费模版-服务费 英转中
export function serviceKeyFilter (key) {
    const SERVICE_CHARGE_KEY_MAP = {
        energy_price: '电费单价',
        pre_price: '预支付总额',
        pre_service_charge_price: '预支付服务费金额',
        service_charge_limit: '服务费时间限制',
        service_charge_price: '服务费单价',
    }
    return SERVICE_CHARGE_KEY_MAP[key]
}
// 计费模版-服务费 加单位
export function serviceValueFilter (val, key) {
    const SERVICE_CHARGE_VALUE_MAP = {
        energy_price: '元/度',
        service_charge_price: '元/小时',
        pre_price: '元',
        pre_service_charge_price: '元',
        service_charge_limit: '分钟',
    }
    return val + SERVICE_CHARGE_VALUE_MAP[key]
}
// 计费模版 编辑 汽车充展示 _6
export function editDecimalFilter(item, key, mode) {
    const TYPE = Const.CHARGE.TYPE
    if (mode === TYPE.TIME_SERVICE) {
        return countFilter(item[key], 100, 6)
    }

    let _key = key + '_6'
    if (item[_key] !== undefined) {
        return countFilter(item[_key], 1000000, 6)
    }
    return countFilter(item[key], 100, 4)
}
// 计费模版 展示 _6
export function decimalFilter(item, key) {
    let _key = key + '_6'
    if (item[_key] !== undefined) {
        return countFilter(item[_key], 1000000, 6)
    }
    return countFilter(item[key], 100, 6)
}

// 计费模版类型
export function chargeTypeFilter (val, to = 'text') {
    const MAP = Const.CHARGE.WAY_MAP
    let ITEM = MAP[val + ''] || {}
    return ITEM[to] || '智能充'
}
/* ======== 计费模板管理 ========== */


/* ======== 订单管理 && 支付管理 ========== */
// 支付信息转换
export function payMessageFilter (dataJson) {
    try {
        let data = JSON.parse(dataJson);
        let message = '';

        // 支付宝相关
        if (data.query_response) {
            message = data.query_response.subMsg
            if (message) {
                return message
            }
        }
        if (data.response) {
            message = data.response.subMsg
            if (message) {
                return message
            }
        }

        // 微信相关
        if (data.query_error !== undefined || data.error !== undefined) {
            const isString = value => {
                try {
                    return typeof value === 'string';
                } catch (error) {
                    return false;
                }
            };

            let errors = []
            if (isString(data.error)) {
                try {
                    let error = JSON.parse(data.error);
                    if (error.return_msg) {
                        errors.push(error.return_msg)
                    }
                } catch (e) {
                    console.log(e)
                }
            }

            if (isString(data.query_error)) {
                try {
                    let error = JSON.parse(data.query_error);
                    if (error.err_code_des) {
                        errors.push(error.err_code_des)
                    }
                } catch (e) {
                    console.log(e)
                }
            }

            if (errors.length > 0) {
                return errors.join(" / ")
            }
        }
    } catch (e) {
        console.log(e);
        return '-'
    }

    return '-'
}
// 支付方式
export function orderPayMethodFormat (val, to = 'text') {
    const MAP = Const.PAY.METHOD_MAP
    let ITEM = MAP[val + ''] || {}
    if (to === 'admin_text') {
        return ITEM[to] || ITEM.text || '-'
    } else {
        return ITEM[to] || '-'
    }
}
// 下单渠道
export function orderBootTypeFormat (val, to = 'text') {
    const MAP = Const.BOOT.TYPE_MAP
    let ITEM = MAP[val + '']
    return ITEM[to] || ''
}
// 结束原因
export function orderFinishCodeFilter (val, map = 'CHARGING', to = 'text') {
    const MAP = Const[map].FINISH_CODE_MAP || {};
    const ITEM = MAP[val + ''] || {};
    return ITEM[to] || ''
}
// 订单退款状态
export function orderRefundStatusFilter (val, to = 'text') {
    const MAP = Const.ORDER.REFUND_STATUS_MAP;
    const ITEM = MAP[val + ''] || { text: '未知', color: 'gray' };
    return ITEM[to] || ''
}
// 订单支付记录的费用科目
export function paySubjectFilter (val, to = 'text') {
    const MAP = Const.PAY.SUBJECT_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
};
// 费用科目
export function orderSubjectFilter (val, to = 'text') {
    const MAP = Const.ORDER.SUBJECT_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
};
// 订单类型
export function orderTypeFilter (val, to = 'text') {
    const MAP = Const.ORDER.TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
// 支付记录状态
export function payStatusFilter (val, to = 'text') {
    const MAP = Const.PAY.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: `未知状态(${val})` }
    return ITEM[to] || ''
};
// 充电类型  是预约充电还是直接充电
export function flagBookingFilter(val, to = 'text') {
    const MAP = Const.ORDER.FLAG_BOOKING_MAP
    let ITEM = MAP[val + ''] || {text: '-'}
    return ITEM[to] || ''
}
// 结算状态 下拉筛选 tooltip
export function clearingStatusTipFilter(val, to = 'text') {
    const MAP = Const.CLEARING.STATUS_MAP || {};
    const ITEM = MAP[val + ''] || {};
    return ITEM[to] || ''
}

// 辅源电压
export function auxiliaryPowerVoltageFilter (val, to = 'text') {
    const MAP = Const.ORDER.AUXILIARY_POWER_VOLTAGE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};

// 双枪并充中的主枪、辅枪
export function parallelChargeGunTypeFilter (val, to = 'text') {
    const MAP = Const.ORDER.PARALLEL_CHARGE_GUN_TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '' }
    return ITEM[to] || ''
};

// 汽车充欠款订单 订单来源
export function purzueParentTypeFilter (val, to = 'text') {
    const MAP = Const.PURSUE.PARENT_TYPE_MAP
    let ITEM = MAP[val + ''] || { text: `未知状态(${val})` }
    return ITEM[to] || ''
};

/* ======== 订单管理 && 支付管理 ========== */


/* ======== 退款管理 ========== */
// 退款申请对象
export function refundTargetTypeFilter (val, to = 'text') {
    const MAP = Const.REFUND.TARGET_TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 退款 申请状态
export function refundStatusTypeFilter (val, to = 'text') {
    const MAP = Const.REFUND.STATUS_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 退款 打款状态
export function refundTransferStatusFilter (val, status, to = 'text') {
    const MAP = Const.REFUND.TRANSFER_STATUS_MAP
    if (val === 0) {
        return refundStatusTypeFilter(status, 'transfer_' + to)
    }
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 退款 打款状态
export function refundRefreshFlag ({ status, transfer_status }) {
    const STATUS = Const.REFUND.STATUS
    const TRANSFER = Const.REFUND.TRANSFER_STATUS
    if (transfer_status === TRANSFER.DOING) {
        return true
    }
    if (transfer_status === TRANSFER.INIT && status === STATUS.AUDIT_SUCCESS) {
        return true
    }
    return false
}
/* ======== 退款管理 ========== */


/* ======== 充电管理 ========== */
// 充电状态
export function orderStatusFilter (val, to = 'text') {
    const MAP = Const.CHARGING.STATUS_MAP;
    const ITEM = MAP[val + ''] || { text: '未知', color: 'gray' };
    return ITEM[to] || ''
}
// 订单导出状态
export function exportStatusFilter (val, to = 'text') {
    const MAP = Const.EXPORT.STATUS_MAP
    const ITEM = MAP[val + ''] || { text: '未知状态' };
    return ITEM[to] || '-'
}
// 订单导出状态
export function exportTypeFilter (val, to = 'text') {
    const MAP = Const.EXPORT.TYPE_MAP
    const ITEM = MAP[val + ''] || { text: '未知' };
    return ITEM[to] || '-'
}
// 订单导出操作人
export function exportOperatorFilter (val, to = 'text') {
    const MAP = Const.EXPORT.OPERATOR_MAP
    const ITEM = MAP[val + ''] || {};
    return ITEM[to] || '-'
}
// 是否是实体卡卡片的充满为止
export function isChargeFullFilter ({ price, charge_mode, pay_method, is_charge_full, detail = {} }) {
    detail = detail ? detail : {}
    let { flag_show_card_price, flag_booking } = detail
    const METHOD_MARK = Const.PAY.METHOD_MARK
    const CHARGE_MARK = Const.CHARGE.CHARGE_MODE_MARK
    const FLAG_BOOKING = Const.ORDER.FLAG_BOOKING
    // 实体卡
    if (METHOD_MARK.REALITY_CARD.includes(pay_method)) {
        if (price === 0) {
            return moneyFilter(price, 3)
        }
        if (flag_show_card_price === undefined && is_charge_full) {
            return '充满为止'
        }
        if (!flag_show_card_price) {
            return '充满为止'
        }
    }
    // 免费支付
    else if (METHOD_MARK.FREE.includes(pay_method)) {
        return moneyFilter(0, 3)
    }
    else {
        if (CHARGE_MARK.FREE.includes(charge_mode)) {
            // 汽车充 预约充电  免费模板  显示价钱  因为包含占位费
            if (CHARGE_MARK.CAR.includes(charge_mode) && flag_booking === FLAG_BOOKING.PRECONTRACT) {
                return moneyFilter(price, 3)
            }
            return moneyFilter(0, 3)
        }
        return moneyFilter(price, 3)
    }
}
// 是否是已结束的订单
export function isFinishOrder (status, type = 'charing') {
    let STATUS = Const.CHARGING.STATUS
    switch (type) {
        case 'charing':
            switch (status) {
                case STATUS.INIT:
                case STATUS.ORDER_PAY:
                case STATUS.OPEN_SUCCESS:
                case STATUS.ORDER_STOP:
                case STATUS.PRE_SUCCESS:
                    return false
                default:
                    return true
            }
        case 'occupy':
            STATUS = Const.OCCUPY.STATUS
            switch (pay) {
                case STATUS.SUCCESS:
                case STATUS.COMPLETE_REFUND:
                    return true
                default:
                    return false
            }
        case 'cabinet':
            STATUS = Const.CABINET.STATUS
            switch (pay) {
                case METHOD.PAY_SUCCESS:
                case METHOD.CANCEL:
                    return true
                default:
                    return false
            }
    }
}
// 是否是用卡片支付的订单
export function isPayByCard (pay, type = 'charing') {
    let METHOD = Const.PAY.METHOD
    switch (type) {
        case 'charing':
            switch (pay) {
                case METHOD.RECHARGE:
                case METHOD.VIRTUAL_RECHARGE:
                case METHOD.MONTH:
                case METHOD.VIRTUAL_MONTH:
                case METHOD.CAR_CARD:
                case METHOD.VIRTUAL_CAR_CARD:
                case METHOD.VIRTUAL_QGL_CARD:
                    return true
                default:
                    return false
            }
        case 'occupy':
            METHOD = Const.OCCUPY.PAY_METHOD
            switch (pay) {
                case METHOD.RECHARGE:
                case METHOD.CAR_CARD:
                    return true
                default:
                    return false
            }
        case 'cabinet':
            METHOD = Const.CABINET.PAY_METHOD
            switch (pay) {
                case METHOD.RECHARGE:
                case METHOD.VIRTUAL_RECHARGE:
                case METHOD.MONTH:
                case METHOD.VIRTUAL_MONTH:
                    return true
                default:
                    return false
            }
    }
}
// 是否是用“现金”
export function isPayByCash (pay, type = 'charing') {
    let METHOD = Const.PAY.METHOD
    switch (type) {
        case 'charing':
            switch (pay) {
                case METHOD.WECHART:
                case METHOD.ALIPAY:
                case METHOD.WX_SCORE:
                case METHOD.CHARGE_FIRST:
                    return true
                default:
                    return false
            }
        case 'occupy':
        case 'pursue':
            METHOD = Const.OCCUPY.PAY_METHOD
            switch (pay) {
                case METHOD.WECHART:
                case METHOD.ALIPAY:
                    return true
                default:
                    return false
            }
        case 'cabinet':
            METHOD = Const.CABINET.PAY_METHOD
            switch (pay) {
                case METHOD.WECHART:
                case METHOD.ALIPAY:
                    return true
                default:
                    return false
            }
    }
}
/* ======== 充电管理 ========== */


/* ======== 充值管理 && 充值任务管理 ========== */
// 充值状态
export function rechargeOrderStatusFilter (val, to = 'text') {
    const MAP = Const.RECHARGE.STATUS_MAP;
    const ITEM = MAP[val + ''] || { text: val === 0 ? '全部' : '未知', color: 'gray' } ;
    return ITEM[to] || ''
}
// 充值卡片类型
export function rechargeModelTypeFilter (val, to = 'text') {
    const MAP = Const.RECHARGE_MODEL.TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 充值卡片类型
export function rechargeTypeFilter (val, to = 'text') {
    const MAP = Const.RECHARGE.CARD_TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}

// 充值任务状态
export function rechargeTaskStatusFilter (val, to = 'text') {
    const MAP = Const.RECHARGE_TASK.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '未知状态', color: 'grey' }
    return ITEM[to] || ''
}
// 充值任务类型
export function rechargeTaskTypeFilter (val, to = 'text') {
    const MAP = Const.RECHARGE_TASK.TYPE_MAP
    let ITEM = MAP[val + ''] || {}
    return ITEM[to] || ''
}
// 充值任务卡片类型
export function rechargeTaskCardTypeFilter (val, to = 'text') {
    const MAP = Const.RECHARGE_TASK.CARD_TYPE_MAP
    let ITEM = MAP[val + ''] || {}
    return ITEM[to] || ''
}
/* ======== 充值管理 && 充值任务管理 ========== */


/* ======== 占用费订单管理 ========== */
// 占用费订单状态
export function occupyOrderStatusFilter (val, to = 'text') {
    const MAP = Const.OCCUPY.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ITEM.text
}
// 欠款订单状态
export function pursueOrderStatusFilter (val, to = 'text') {
    const MAP = Const.PURSUE.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 占用费订单支付方式
export function occupyOrderPayMethodFormat (val, to = 'text') {
    const MAP = Const.OCCUPY.PAY_METHOD_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}

// 占用费订单类型
export function occupyOrderTypeFilter (val, to = 'text') {
    const MAP = Const.OCCUPY.TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
/* ======== 占用费订单管理 ========== */


/* ======== 换电柜订单管理 ========== */
// 换电柜订单状态
export function cabinetOrderStatusFilter (val, to = 'text') {
    const MAP = Const.CABINET.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 换电柜订单支付方式
export function cabinetOrderPayMethodFormat (val, to = 'text') {
    const MAP = Const.CABINET.PAY_METHOD_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}

export function cabinetPackageFilter (val, to = 'text') {
    const MAP = Const.CABINET.PACKAGE_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}

export function packageRemainTime ({ status, end_time = 0 }) {
    if (status === Const.CABINET.PACKAGE_STATUS.PASS) { return { desc: '已失效' } }

    let end = dayjs.unix(end_time)
    let now = dayjs()

    let sec = end.diff(now, 's')

    if (sec <= 0) { return { desc: '已过期' } }

    let day = end.diff(now, 'd')
    return { value: day + 1, unit: '天', desc: '生效中' }
}
export function cabinetLogStatusFilter (val, to = 'text') {
    const MAP = Const.CABINET.LOG_STATUS_MAP
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    return ITEM[to] || ''
}
export function cabinetLogTypeFilter (val, to = 'text') {
    const MAP = Const.CABINET.LOG_TYPE_MAP
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    return ITEM[to] || ''
}
export function cabinetLogFinishFilter (val, to = 'text', data) {
    const MAP = Const.CABINET.LOG_FINISH_MAP
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    if (ITEM.need_more) {
        let arr = (ITEM[to] || '').split('[]')
        arr.splice(1, 0, `[${data}]`)
        return arr.join('')
    } else {
        return ITEM[to] || ''
    }
}
export function cabinetLogReturnFilter (val, to = 'text') {
    const MAP = Const.CABINET.LOG_RETURN_MAP
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    return ITEM[to] || ''
}
export function cabinetExchangeModeFilter (val, to = 'text') {
    const MAP = Const.CABINET.EXCHANGE_MDOE_MAP
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    return ITEM[to] || ''
}
export function cabinetResultCodeFilter (val, to = 'text') {
    const MAP = Const.CABINET.RESULT_CODE
    const ITEM = MAP[val + ''] || { color: 'gray', text: '-' }
    return ITEM[to] || ''
}
/* ======== 换电柜订单管理 ========== */


/* ======== 服务费管理 ========== */
export function serviceChargeModeFilter (val, to = 'text') {
    const MAP = Const.SERVICE_CHARGE.PAY_MODE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
export function serviceChargeSubjectFilter (val, to = 'text') {
    const MAP = Const.SERVICE_CHARGE.DEVICE_SUBJECT_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || ''
}
// 服务费-线上支付订单审核操作类型
export function serviceChargeAuditTypeFilter (val, to = 'text') {
    const MAP = Const.CHARGING.AUDIT_TYPE_MAP
    const ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
/* ======== 服务费管理 ========== */


/* ======== 结算管理 && 转账管理 && 虚拟账户管理 ========== */
// 结算单转态
export function clearingStatusFilter (val, to = 'text') {
    const MAP = Const.CLEARING.STATUS_MAP
    let ITEM = MAP[val + ''] || {}
    return ITEM[to] || '-'
}
// 结算失败原因
export function clearingFinishCodeFilter (val, to = 'text') {
    const MAP = Const.CLEARING.FINISH_CODE_MAP;
    const ITEM = MAP[val + ''] || {};
    return ITEM[to] || '-'
}
// 虚拟账户渠道
export function channelFilter (val, to = 'text') {
    const MAP = Const.CHANNEL_MAP
    let ITEM = MAP[val + ''] || { text: '默认', icon: 'i-no_type_in' }
    return ITEM[to] || ''
}
// 虚拟账户 - 银行账户类型
export function bankAccountTypeFilter (val, to = 'text') {
    const MAP = Const.BANK_ACCOUNT.TYPE_MAP
    let ITEM = MAP[val + ''] || {}
    return ITEM[to] || ''
}
// 转账打款状态
export function transferRemitStatusFilter (val, to = 'text') {
    const MAP = Const.TRANSFER.REMIT_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
// 转账打款审核状态
export function auditStatusFilter (val, to = 'text') {
    const MAP = Const.TRANSFER.AUDIT_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
// 打款周期
export function accountPeriodFilter (val, to = 'text') {
    let MAP = Const.TRANSFER.PERIOD_MAP
    let ITEM = MAP[val + ''] || { text: 'D+1', desc: '每天凌晨收到昨天收益打款' }   // T+1
    return ITEM[to] || '-'
}

export function orderRemitStatusFilter (val, to = 'text') {
    const MAP = Const.REMIT_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
export function paymentRemitStatusFilter (val, to = 'text') {
    const MAP = Const.PAYMENT_REMIT_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
};
/* ======== 结算管理 && 转账管理 && 虚拟账户管理 ========== */


/* ======== 卡片管理 ========== */
// 实体卡片状态
export function cardStatusFilter (val, type = 'reality', to = 'text') {
    let MAP = Const.CARD.STATUS_MAP
    if (type === 'virtual') {
        MAP = Const.CARD.VIRTUAL_STATUS_MAP
    } else if (type === 'team_vin') {
        MAP = Const.CARD.VIRTUAL_VIN_STATUS_MAP
    }
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 卡片类型
export function cardTypeFilter (val, to = 'text') {
    const MAP = Const.CARD.TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '-' }
    return ITEM[to] || ''
}
// 卡片操作错误码
export function cardErrorCodeFilter (val, to = 'text') {
    const MAP = Const.CARD.ERROR_CODE_MAP
    let ITEM = MAP[val + ''] || { text: '未知异常' }
    return ITEM[to] || ''
}
// 卡片操作人类型
export function cardOperatorFilter (val, to = 'text') {
    const MAP = Const.CARD.OPERATOR_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
}
// 卡片金额变动科目
export function cardSubjectFilter (val, type = 1) {
    // type 1:实体卡 2:虚拟卡
    const MAP = type == 1 ? Const.CARD.REALITY_SUBJECT_MAP : Const.CARD.VIRTUAL_SUBJECT_MAP
    return MAP[val] || '-'
}
// 卡片金额变动科目
export function cardOperationFilter (val, type = 1) {
    // type 1:实体卡 2:虚拟卡
    const MAP = type == 1 ? Const.CARD.REALITY_OPERATION_MAP : Const.CARD.VIRTUAL_OPERATION_MAP
    return MAP[val] || '-'
}
/* ======== 卡片管理 ========== */


/* ======== 统计管理 ========== */
export function statTimeTypeFilter (type) {
    switch (type) {
        case 1: return '日';
        case 2: return '周';
        case 3: return '月';
        case 4: return '年';
    }
}
/* ======== 统计管理 ========== */


/* ======== 告警管理 ========== */
// 告警内容
export function alarmContentFilter (alarm) {
    if (alarm.data) {
        let data = JSON.parse(alarm.data)
        return ((data.port_index === 127 || data.port_index === 255) ? '整个设备' : (parseInt(data.port_index) + 1) + '号口') +
            (Const.ALARM.EVENT_CODE_MAP[(data.event || data.charge_event) + ''] || `未知事件(${data.event || data.charge_event})`)
    }
    return alarm.content
}
// 告警状态
export function alarmStatusFilter (val, to = 'text') {
    const MAP = Const.ALARM.STATUS_MAP
    let ITEM = MAP[val + ''] || { text: '未知状态', color: 'gray' }
    return ITEM[to] || ''
}
// 告警来源
export function alarmSourceFilter (val, to = 'text') {
    const MAP = Const.ALARM.SOURCE_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
}
// 告警科目
export function alarmSubjectFilter (val, to = 'text') {
    const MAP = Const.ALARM.SUBJECT_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
}
/* ======== 告警管理 ========== */


/* ======== 广告管理 ========== */
// 广告场景
export function advertisingSceneFilter (val, to, def) {
    const LIST = Const.ADVERTISING.SCENE_LIST
    let ITEM = LIST.find(item => item.value === parseInt(val)) || {text:"未知"}
    return (to ? (ITEM[to] || '') : ITEM) || def
}
/* ======== 广告管理 ========== */

/* ======== 操作记录管理 ========== */
// 操作者类型
export function actionOperatorFilter (val, to = 'text') {
    const MAP = Const.ACTION.OPERATOR_TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
}
// 操作对象类型
export function actionTargetFilter (val, to = 'text') {
    const MAP = Const.ACTION.TARGET_TYPE_MAP
    let ITEM = MAP[val + ''] || { text: '未知' }
    return ITEM[to] || ''
}
/* ======== 操作记录管理 ========== */

/* ======== 汽车充预约充电 ========== */
    // 操作者类型
    export function flagPreChrageFilter(val, to = 'text') {
        const MAP = Const.CHARGE.CAR_OCCUPY.FLAG_CHARGE_MAP
        let ITEM = MAP[val + ''] || {text: '未知'}
        return ITEM[to] || ''
    }
/* ======== 操作记录管理 ========== */
/* ======== 车辆管理 ========== */
    // 状态
    export function carListWeightFilter(val, to = 'text') {
        const MAP = Const.VIN.WEIGHT_MAP
        let ITEM = MAP[val + ''] || {text: '未知'}
        return ITEM[to] || ''
    }
/* ======== 车辆管理 ========== */

/* ======== 设备型号管理 ========== */
// 设备型号类型
// export function deviceModelTypeFilter(val, to = 'text') {
//     const MAP = Const.DEVICE_MODEL.TYPE_MAP
//     let ITEM = MAP[val + ''] || {text: '未知'}
//     return ITEM[to] || ''
// }
/* ======== 设备型号管理 ========== */

/* ======== 保险管理 ========== */
export function insuranceStatusFilter(val, to = 'text') {
	const MAP = Const.INSURANCE.STATUS_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
export function insuranceRefundStatusFilter(val, to = 'text') {
	const MAP = Const.INSURANCE.REFUND_STATUS_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
// 出单源
export function insuranceTypeFilter(val, to = 'text') {
	const MAP = Const.INSURANCE.TYPE_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}

/* ======== 保险管理 ========== */

/* ======== 运营商定制管理 ========== */
export function payReceiptChannelFilter(val, to = 'text') {
	const MAP = Const.PAY_RECEIPT.CHANNEL_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
export function smsConfigScenefilter(val, to = 'text') {
	const MAP = Const.SMS_CONFIG.SCENE_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
/* ======== 运营商定制管理 ========== */

/* ======== 消息管理-反馈工单 ========== */
// 场景
export function feedbackSceneFilter(val, to = 'text') {
	const MAP = Const.FEEDBACK.SCENE_TYPE_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
// 工单状态
export function feedbackStatusFilter(val, to = 'text') {
	const MAP = Const.FEEDBACK.STATUS_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
// 处理进度
export function feedbackProgressFilter(val, to = 'short_text') {
	const MAP = Const.FEEDBACK.PROGRESS_MAP;
	const ITEM = MAP[val + ''] || {};
	return ITEM[to] || '-';
}
/* 卡片咨询 */
// 退款记录状态
export function refundStatusFilter (val, to = 'text') {
    const MAP = Const.FEEDBACK.RECHARGE.REFUND_STATUS_MAP
    let ITEM = MAP[val + ''] || { text: `未知状态(${val})` }
    return ITEM[to] || ''
}
/* 开票申请 */

/* ======== 消息管理-反馈工单 ========== */
